import { Component } from '@angular/core';

@Component({
    selector: 'vee-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    standalone: false
})
export class LogoComponent {}
